var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledHospital24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Site Statuses") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Filled/hospital_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "\\uD83C\\uDF08-Icon-Color"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hospital",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14,15.375 L14,16 L0,16 L0,15.375 C0,15.1679062 0.16790625,15 0.375,15 L1,15 L1,3.75 C1,3.33578125 1.33578125,3 1.75,3 L4.5,3 L4.5,0.75 C4.5,0.33578125 4.83578125,0 5.25,0 L8.75,0 C9.16421875,0 9.5,0.33578125 9.5,0.75 L9.5,3 L12.25,3 C12.6642187,3 13,3.33578125 13,3.75 L13,15 L13.625,15 C13.8320938,15 14,15.1679062 14,15.375 Z M9.625,6 L8.375,6 C8.16790625,6 8,6.16790625 8,6.375 L8,7.625 C8,7.83209375 8.16790625,8 8.375,8 L9.625,8 C9.83209375,8 10,7.83209375 10,7.625 L10,6.375 C10,6.16790625 9.83209375,6 9.625,6 Z M4.375,8 L5.625,8 C5.83209375,8 6,7.83209375 6,7.625 L6,6.375 C6,6.16790625 5.83209375,6 5.625,6 L4.375,6 C4.16790625,6 4,6.16790625 4,6.375 L4,7.625 C4,7.83209375 4.16790625,8 4.375,8 Z M7.625,12 L6.375,12 C6.16790625,12 6,12.1679062 6,12.375 L6,15 L8,15 L8,12.375 C8,12.1679062 7.83209375,12 7.625,12 Z M9.625,9 L8.375,9 C8.16790625,9 8,9.16790625 8,9.375 L8,10.625 C8,10.8320938 8.16790625,11 8.375,11 L9.625,11 C9.83209375,11 10,10.8320938 10,10.625 L10,9.375 C10,9.16790625 9.83209375,9 9.625,9 Z M6,9.375 C6,9.16790625 5.83209375,9 5.625,9 L4.375,9 C4.16790625,9 4,9.16790625 4,9.375 L4,10.625 C4,10.8320938 4.16790625,11 4.375,11 L5.625,11 C5.83209375,11 6,10.8320938 6,10.625 L6,9.375 Z M5.6875,3 L6.5,3 L6.5,3.8125 C6.5,3.91605339 6.58394661,4 6.6875,4 L7.3125,4 C7.41605339,4 7.5,3.91605339 7.5,3.8125 L7.5,3 L8.3125,3 C8.41605339,3 8.5,2.91605339 8.5,2.8125 L8.5,2.1875 C8.5,2.08394661 8.41605339,2 8.3125,2 L7.5,2 L7.5,1.1875 C7.5,1.08394661 7.41605339,1 7.3125,1 L6.6875,1 C6.58394661,1 6.5,1.08394661 6.5,1.1875 L6.5,2 L5.6875,2 C5.58394661,2 5.5,2.08394661 5.5,2.1875 L5.5,2.8125 C5.5,2.91605339 5.58394661,3 5.6875,3 Z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledHospital24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_hospital_24px.b898769b.svg";
export { ForwardRef as ReactComponent };